export const REPORTS = {
  GRADES: 'grades',
  QUALITY: 'quality-dashboard',
  QUALITY_DASHBOARD_DETAILS: 'quality-dashboard-details',
  BUSINESS: 'business',
  BACKBOX: 'backbox',
}

export const FAQ_ARTICLE_LINKS = {
  [REPORTS.QUALITY]: {
    'fr-fr':
      'https://merchant-support.backmarket.com/hc/fr/articles/360019402860-Onglet-Insights-Indicateurs-qualit%C3%A9',
    'en-us':
      'https://merchant-support.backmarket.com/hc/en-us/articles/360019402860-Insights-tab-Quality-indicators-in-the-Back-Office',
    default:
      'https://merchant-support.backmarket.com/hc/en-gb/articles/360019402860-Insights-tab-Quality-indicators-in-the-Back-Office',
  },
  [REPORTS.BUSINESS]: {
    'fr-fr':
      'https://merchant-support.backmarket.com/hc/fr/articles/4408499155858-Dashboard-Sales-Insights-',
    'en-us':
      'https://merchant-support.backmarket.com/hc/en-us/articles/4408499155858-Sales-Insights-Dashboard',
    default:
      'https://merchant-support.backmarket.com/hc/en-gb/articles/4408499155858-Sales-Insights-Dashboard',
  },
  [REPORTS.BACKBOX]: {
    'fr-fr':
      'https://backmarket.my.site.com/ssc/s/article/Tableau-de-bord-BackBox-Insights',
    'en-us':
      'https://backmarket.my.site.com/ssc/s/article/BackBox-Insights-dashboard',
    default:
      'https://backmarket.my.site.com/ssc/s/article/BackBox-Insights-dashboard',
  },
} as Record<string, Record<string, string>>

export const CANNOT_ACCES_LINK_URL =
  'https://kb.tableau.com/articles/issue/login-fails-or-login-prompt-continuously-appears-in-embedded-view-with-safari'

export const FAQ_TABLEAU_URL =
  'https://kb.tableau.com/articles/issue/login-fails-or-login-prompt-continuously-appears-in-embedded-view-with-safari'
